<template>
  <div class="contact-page">
    <!-- QR Code Modal -->
    <div v-if="showQRModal" class="modal-overlay" @click.self="closeQRModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeQRModal">×</button>
        <h3>加入 QQ 群</h3>
        <p>扫描二维码加入用户交流群</p>
        <img src="~@/assets/img/qqcode2.png" alt="QQ群二维码" class="qr-image"/>
      </div>
    </div>

    <!-- Header -->
    <section class="page-header">
      <div class="container">
        <h1>联系我</h1>
        <p>有问题或建议？欢迎与我们取得联系</p>
      </div>
    </section>

    <!-- Contact Options -->
    <section class="contact-options">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-card">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3>问题反馈</h3>
            <p>遇到 Bug 或有功能建议？欢迎提交反馈，帮助我们改进产品。</p>
            <a href="mailto:wonder1999@126.com" class="contact-link">wonder1999@126.com</a>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <h3>开源项目</h3>
            <p>MookNote 是开源项目，欢迎访问 GitHub 仓库，提交 Issue 或 PR。</p>
            <a href="https://github.com/dellevin/mooknote" class="contact-link" >GitHub 仓库</a>
          </div>
          <div class="contact-card">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h3>社区交流</h3>
            <p>加入用户交流群，与其他用户分享使用心得和技巧。</p>
            <a href="#" class="contact-link" @click.prevent="openQRModal">加入群组</a>
          </div>
        </div>
      </div>
    </section>



    <!-- About -->
    <section class="about-section">
      <div class="container">
        <div class="about-content">
          <h2>关于 MookNote</h2>
          <p>MookNote 是一款专注于个人记录的应用，诞生于对简洁工具的追求。我相信，好的工具应该像纸笔一样自然，不打扰思考，只记录生活。</p>
          <p>我希望一款好的软件应该做到的是不断听取使用者意见，不断改进和优化，数据归于用户，不做任何侵犯用户隐私的事情，只提供最简单最实用的功能。</p>
          <p>应用采用 Flutter 框架开发。</p>
        </div>
      </div>
    </section>

    <!-- Changelog -->
    <section class="changelog-section">
      <div class="container">
        <h2 class="section-title">更新日志</h2>
        <div class="timeline">
          <div v-for="(log, index) in changelogs" :key="index" class="timeline-item">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <div class="timeline-header">
                <h3>{{ log.version }}</h3>
                <span class="timeline-date">{{ log.date }}</span>
              </div>
              <ul>
                <li v-for="(feature, fIndex) in log.features" :key="fIndex">{{ feature }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      form: {
        name: '',
        email: '',
        type: '',
        message: ''
      },
      submitting: false,
      showQRModal: false,
      changelogs: [
        {
          version: 'v0.1.7',
          date: '2025年3月',
          features: [
            '编辑影视左上角点击豆瓣分享的链接，可自动解析并添加',
            '封面可上传网络图片',
            '优化底部dock栏目，左侧弹出框',
            '添加豆瓣分享的链接，可自动解析并添加',
            '设置新增功能，清除无效图片',
          ]
        },
        {
          version: 'v0.1.6',
          date: '2025年3月',
          features: [
            '可控制主界面功能的显示',
            '底部加号长按添加对应数据（观影/阅读/笔记）',
            '优化我的界面显示',
            '优化影评/书评页面显示内容',
            '优化影评/书评详情页面显示内容',
            '优化笔记列表/详情/编辑界面',
            '优化回收站界面显示',
            '评分星星在首页展开显示（多颗星星）',
            '支持修改已看/已读时间'
          ]
        },
        {
          version: 'v0.1.5',
          date: '2025年2月',
          features: [
            '首个公开版本发布',
            '支持观影、阅读、笔记三大模块',
            '本地备份与 WebDAV 云备份功能',
            '数据统计与热力图展示'
          ]
        }
      ]
    }
  },
  methods: {
    showComingSoon() {
      alert('功能即将上线，敬请期待！')
    },
    openQRModal() {
      this.showQRModal = true
    },
    closeQRModal() {
      this.showQRModal = false
    }
  }
}
</script>

<style scoped>
/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 32px;
  border-radius: 16px;
  text-align: center;
  position: relative;
  max-width: 360px;
  width: 90%;
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: var(--color-text-secondary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: var(--color-text);
}

.modal-content h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--color-text);
}

.modal-content p {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin-bottom: 20px;
}

.qr-image {
  width: 200px;
  height: 250px;
  border-radius: 8px;
}

/* Page Header */
.page-header {
  padding: 100px 24px 60px;
  background: var(--color-bg-secondary);
  text-align: center;
}

.page-header h1 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--color-text);
}

.page-header p {
  font-size: 17px;
  color: var(--color-text-secondary);
}

/* Contact Options */
.contact-options {
  padding: 80px 24px;
  background: white;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.contact-card {
  padding: 40px 32px;
  background: var(--color-bg-secondary);
  border-radius: 16px;
  text-align: center;
  transition: transform 0.2s;
}

.contact-card:hover {
  transform: translateY(-4px);
}

.contact-icon {
  width: 64px;
  height: 64px;
  background: white;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  color: var(--color-text);
}

.contact-icon svg {
  width: 28px;
  height: 28px;
}

.contact-card h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--color-text);
}

.contact-card p {
  font-size: 15px;
  color: var(--color-text-secondary);
  line-height: 1.7;
  margin-bottom: 20px;
}

.contact-link {
  color: var(--color-text);
  font-weight: 500;
  text-decoration: none;
  border-bottom: 1px solid var(--color-border);
  padding-bottom: 2px;
  transition: border-color 0.2s;
}

.contact-link:hover {
  border-color: var(--color-text);
}

/* Feedback Section */
.feedback-section {
  padding: 80px 24px;
  background: var(--color-bg-secondary);
}

.feedback-wrapper {
  display: flex;
  gap: 80px;
  max-width: 1000px;
  margin: 0 auto;
}

.feedback-info {
  flex: 1;
}

.feedback-info h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--color-text);
}

.feedback-info p {
  font-size: 16px;
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: 32px;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: var(--color-text-secondary);
}

.info-icon {
  width: 24px;
  height: 24px;
  background: var(--color-text);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}

.feedback-form {
  flex: 1;
  background: white;
  padding: 40px;
  border-radius: 16px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text);
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  background: white;
  color: var(--color-text);
  transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-text);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: var(--color-text-muted);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.btn-block {
  width: 100%;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* About Section */
.about-section {
  padding: 80px 24px;
  background: white;
}

.about-content {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.about-content h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 24px;
  color: var(--color-text);
}

.about-content p {
  font-size: 16px;
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: 16px;
}

.about-stats {
  display: flex;
  justify-content: center;
  gap: 64px;
  margin-top: 48px;
  padding-top: 48px;
  border-top: 1px solid var(--color-border);
}

.about-stat {
  text-align: center;
}

.as-number {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
}

.as-label {
  font-size: 14px;
  color: var(--color-text-muted);
  margin-top: 4px;
}

/* Changelog */
.changelog-section {
  padding: 80px 24px;
  background: var(--color-bg-secondary);
}

.timeline {
  max-width: 720px;
  margin: 48px auto 0;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: var(--color-border);
}

.timeline-item {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
  position: relative;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  width: 18px;
  height: 18px;
  background: var(--color-text);
  border-radius: 50%;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.timeline-content {
  flex: 1;
  background: white;
  padding: 24px;
  border-radius: 12px;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.timeline-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
}

.timeline-date {
  font-size: 13px;
  color: var(--color-text-muted);
}

.timeline-content ul {
  padding-left: 20px;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 2;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header h1 {
    font-size: 32px;
  }

  .feedback-wrapper {
    flex-direction: column;
    gap: 40px;
  }

  .feedback-form {
    padding: 24px;
  }

  .about-stats {
    gap: 32px;
  }

  .timeline-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
</style>
